module.exports = __webpack_public_path__ + "static/media/favicon.9bf36fe4.ico";